export const getRelatedItemsBasedOnProvidedId = (item, items, isStrict) => items.filter(i => {
  const isRelatedIdsSame = item.asRelatedItemId && i.asRelatedItemId && i.asRelatedItemId === item.asRelatedItemId;
  if (!isStrict) {
    return isRelatedIdsSame;
  }
  const isIdSame = item._id && i._id && String(item._id) === String(i._id);
  const isProdIdSame = item.prodId === i.prodId;
  return isRelatedIdsSame && !isProdIdSame && !isIdSame;
});